<nav class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white" id="sidenav-main"
  (mouseover)="onMouseEnterSidenav()" (mouseout)="onMouseLeaveSidenav()" *ngIf="!isLogin && !isHomepage">

  <ng-scrollbar visibility="hover">
    <div class="scrollbar-inner" onmousedown='return false;' onselectstart='return false;'>
      <div class="sidenav-header d-flex align-items-center">
        <a class="navbar-brand" [routerLink]="['welcome']">
          <img src="https://apmidasstorage.blob.core.windows.net/cdn/logo_teadit_branco.png" class="navbar-brand-img mr-6" alt="..." />
        </a>
        <!-- Sidenav toggler -->
        <div class="sidenav-toggler d-none d-xl-block" data-action="sidenav-unpin" data-target="#sidenav-main"
          (click)="minimizeSidebar()">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </div>
      <div class="navbar-inner">
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a routerLinkActive="active" [routerLink]="['welcome']" class="nav-link mousePointer">
                <i class="fa fa-home text-primary"></i>
                <span class="nav-link-text">Início</span>
              </a>
            </li>
            <li *ngFor="let menuitem of modulos | orderby:'nome'; index as i" class="nav-item">
              <a data-toggle="collapse" routerLinkActive="active" (click)="menuitem.show = !menuitem.show"
                [attr.aria-expanded]="menuitem.show" [attr.aria-controls]="'menu-collapse-' + i"
                class="nav-link mousePointer">
                <i class="ni {{ menuitem.icone }}"></i>
                <span class="nav-link-text">{{ menuitem.nome }}</span>
              </a>
              <ul class="nav nav-sm flex-column collapse" [class.show]="menuitem.show" [attr.id]="'menu-collapse-' + i">
                <li *ngFor="let childitems of menuitem.children" class="nav-item">

                  <a routerLinkActive="active" (click)="status(menuitem.url, childitems.url)"
                    class="nav-link mousePointer">
                    {{ childitems.nome }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </ng-scrollbar>
</nav>
